import axios from "axios";
import { SERVER } from "../Constants";

const authorization = localStorage.getItem("Authorization");
export const axiosFetcher = axios.create({
    baseURL: SERVER,
    timeout: 400000,
    headers: { Authorization: authorization },
});
